import React, { useMemo, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  FormControl,
  MenuItem,
  Select,
} from 'omaha-design-system';
import { IRootState } from '../../../store/reducer';
import { setStateFilter } from '../store/slice';
import { fetchStateSportsbooks, StateData } from '../data/stateSportsbooksApi';

interface PropsStateDropdownProps {
  size?: 'small' | 'medium';
}

const PropsStateDropdown: React.FC<PropsStateDropdownProps> = ({ size = 'small' }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((s: IRootState) => s.stokasticProps);
  const [stateData, setStateData] = useState<StateData[]>([]);

  // Fetch state sportsbooks data on mount
  useEffect(() => {
    fetchStateSportsbooks().then(setStateData);
  }, []);

  // Derive legalized states from API data
  const legalizedStates = useMemo(() => {
    return stateData
      .filter(s => s.isLegalized && s.sportsbooks.length > 0)
      .map(s => ({ value: s.abbreviation, label: s.name }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [stateData]);

  return (
    <FormControl size={size} sx={{ minWidth: 100 }}>
      <Select
        value={filters.state}
        onChange={(e) => dispatch(setStateFilter(e.target.value))}
        displayEmpty
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '6px',
          color: '#F2F2F3',
          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
          '& .MuiSelect-select': { py: 1, px: 1.5 },
          '& svg': { color: '#F2F2F3' },
        }}
      >
        {legalizedStates.map((st) => (
          <MenuItem key={st.value} value={st.value}>
            {st.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PropsStateDropdown;
